var React = require('react');

function Ball12 (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M89.1,15c0,7.8-6,14.1-13.3,14.1H14.2C6.9,29.1,0.9,22.8,0.9,15c0-7.8,6-14.1,13.3-14.1h61.6C83.1,0.9,89.1,7.2,89.1,15\n\t\tL89.1,15z M89.1,15","key":0}),React.createElement("path",{"d":"M89.1,75c0,7.8-6,14.1-13.3,14.1H14.2C6.9,89.1,0.9,82.8,0.9,75c0-7.8,6-14.1,13.3-14.1h61.6C83.1,60.9,89.1,67.2,89.1,75\n\t\tL89.1,75z M89.1,75","key":1}),React.createElement("path",{"d":"M89.1,45c0,7.8-6,14.1-13.3,14.1H14.2C6.9,59.1,0.9,52.8,0.9,45c0-7.8,6-14.1,13.3-14.1h61.6C83.1,30.9,89.1,37.2,89.1,45\n\t\tL89.1,45z M89.1,45","key":2})]));
}

Ball12.defaultProps = {"viewBox":"0 0 90 90"};

module.exports = Ball12;

Ball12.default = Ball12;
